// Standalone i18n instance — kept outside main.ts so that modules which only
// need to translate strings (e.g. stores/menu.ts) can import it without pulling
// in the entire app bootstrap. Importing from '@/main' produced a cycle
//   main.ts → router → Body.vue → Sidebar → useMenu → @/main
// which used to be papered over by defineAsyncComponent's dynamic import,
// and now surfaces as "Cannot access 'X' before initialization" the moment
// any layout child is imported synchronously.
import { createI18n } from 'vue-i18n';
import ru from '@/core/locales/ru.json';
import uz from '@/core/locales/uz.json';
import en from '@/core/locales/en.json';
export const i18n = createI18n({
    legacy: false,
    locale: 'ru',
    fallbackLocale: 'en',
    messages: { ru, uz, en },
});
